// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"523":"6ad009dd7b335620","555":"bc9125fd164e71ca","778":"70794f2d20d81ed6","839":"5e6ec3615517c540","978":"790fba0ea34261e5"}[chunkId] + ".js";
};